export const CORTEX_NAVIGATION_ITEMS = [
  {
    key: 'overview',
    name: 'Cortex Overview',
    icon: 'i-lucide-layout-dashboard',
    permission: 'manage',
    pageLabelKey: 'CORTEX.SIDEBAR.OVERVIEW',
    sidebarLabelKey: 'SIDEBAR.CORTEX_OVERVIEW',
  },
  {
    key: 'agents',
    name: 'Cortex Agents',
    icon: 'i-lucide-bot',
    permission: 'manage',
    pageLabelKey: 'CORTEX.SIDEBAR.AGENTS',
    sidebarLabelKey: 'SIDEBAR.CORTEX_AGENTS',
  },
  {
    key: 'knowledge',
    name: 'Cortex Knowledge',
    icon: 'i-lucide-book-open',
    permission: 'manage',
    pageLabelKey: 'CORTEX.SIDEBAR.KNOWLEDGE_BASES',
    sidebarLabelKey: 'SIDEBAR.CORTEX_KNOWLEDGE_BASES',
  },
  {
    key: 'settings',
    name: 'Cortex Model Conversion',
    icon: 'i-lucide-settings-2',
    permission: 'manage',
    pageLabelKey: 'CORTEX.SIDEBAR.MODEL_AND_CONVERSION',
    sidebarLabelKey: 'SIDEBAR.CORTEX_MODEL_AND_CONVERSION',
  },
  {
    key: 'tools',
    name: 'Cortex Tools',
    icon: 'i-lucide-wrench',
    permission: 'manage',
    pageLabelKey: 'CORTEX.SIDEBAR.TOOLS',
    sidebarLabelKey: 'SIDEBAR.CORTEX_TOOLS',
  },
  {
    key: 'playground',
    name: 'Cortex Playground',
    icon: 'i-lucide-terminal',
    permission: 'manage',
    pageLabelKey: 'CORTEX.SIDEBAR.PLAYGROUND',
    sidebarLabelKey: 'SIDEBAR.CORTEX_PLAYGROUND',
  },
  {
    key: 'processing',
    name: 'Cortex Processing',
    icon: 'i-lucide-database-zap',
    permission: 'manage',
    pageLabelKey: 'CORTEX.SIDEBAR.PROCESSING',
    sidebarLabelKey: 'SIDEBAR.CORTEX_PROCESSING',
  },
  {
    key: 'costs',
    name: 'Cortex Usage',
    icon: 'i-lucide-circle-dollar-sign',
    permission: 'manage',
    pageLabelKey: 'CORTEX.SIDEBAR.USAGE_COSTS',
    sidebarLabelKey: 'SIDEBAR.CORTEX_USAGE_COSTS',
  },
  {
    key: 'audit',
    name: 'Cortex Audit',
    icon: 'i-lucide-scroll-text',
    permission: 'audit',
    pageLabelKey: 'CORTEX.SIDEBAR.AUDIT',
    sidebarLabelKey: 'SIDEBAR.CORTEX_AUDIT',
  },
];

export const getCortexNavigationItems = ({
  canManage,
  canViewAudit,
  labelKey = 'pageLabelKey',
  translate,
}) =>
  CORTEX_NAVIGATION_ITEMS.filter(
    item =>
      (item.permission === 'manage' && canManage) ||
      (item.permission === 'audit' && canViewAudit)
  ).map(item => ({
    key: item.key,
    name: item.name,
    label: translate(item[labelKey]),
    icon: item.icon,
  }));
